<template>
    <main-content with_go_back_bar>
        <shareholder-form :submit="update"
                          :submit_btn_text="$t('btn.submit_changes')"
                          :form_data="form_data"
        >
        </shareholder-form>
    </main-content>
</template>

<script>
    import mainContent from "@/components/main-content";
    import shareholderForm from './components/shareholder-form'
    import {walletService} from "@/common/api.service";

    export default {
        components: {
            mainContent,
            shareholderForm,
        },
        data() {
            return {
                form_data: {
                    first_name: '',
                    last_name: '',
                    account_numbers: [''],
                    wallet_hashid: '',
                },
            };
        },
        methods: {
            update() {
                let account_numbers = [];

                for (let item of this.form_data.account_numbers) {
                    if (item !== '' && item != null) {
                        account_numbers.push(item);
                    }
                }

                let params = {
                    first_name: this.form_data.first_name,
                    last_name: this.form_data.last_name,
                    wallet_hashid: this.form_data.wallet_hashid,
                    account_numbers: account_numbers,
                };
                let updateShareHolder = this.$can('manage-stakeholder', 'user') ?
                    walletService.shareholderUpdateByAdmin :
                    walletService.shareholderUpdate;

                updateShareHolder(params, this.$route.params.hashid).then(res => {
                    this.$router.push('/shareholders');
                });
            },
        },
        mounted() {
            let shareHolderDetail = this.$can('manage-stakeholder', 'user') ?
                walletService.shareholderDetailByAdmin :
                walletService.shareholderDetail;

            shareHolderDetail(this.$route.params.hashid).then(res => {
                this.form_data.first_name = res.data.data.first_name;
                this.form_data.last_name = res.data.data.last_name;
                this.form_data.account_numbers = res.data.data.account_numbers;
                this.form_data.wallet_hashid = res.data.data.wallet_hashid;

                if (this.form_data.account_numbers.length === 0) {
                    this.form_data.account_numbers.push('');
                }
            });
        },
    }
</script>
